import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../static/icons/upload_icon.svg'


const _hoisted_1 = { class: "person-general-info__subtitle" }
const _hoisted_2 = { class: "person-general-info__info" }
const _hoisted_3 = { class: "person-general-info__thumbnail-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "person-general-info__profile-image-overlay" }, null, -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "person-general-info__profile-image"
}
const _hoisted_8 = { class: "person-general-info__details" }
const _hoisted_9 = {
  for: "pperson-general-info__file-upload",
  class: "tertiary-button person-general-info__upload-image pperson-general-info__upload-label"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "upload-icon"
}, null, -1)
const _hoisted_11 = { class: "person-general-info__field-group" }
const _hoisted_12 = {
  class: "person-general-info__label",
  for: "firstName"
}
const _hoisted_13 = { class: "person-general-info__field-group" }
const _hoisted_14 = {
  class: "person-general-info__label",
  for: "lastName"
}
const _hoisted_15 = { class: "person-general-info__field-group" }
const _hoisted_16 = {
  class: "person-general-info__label",
  for: "phoneInput"
}
const _hoisted_17 = { class: "person-general-info__field-group" }
const _hoisted_18 = {
  class: "person-general-info__label",
  for: "title"
}
const _hoisted_19 = { class: "person-general-info__field-group" }
const _hoisted_20 = {
  class: "person-general-info__label",
  for: "bio"
}
const _hoisted_21 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import useContext from '@/composables/useContext';
import useLitium from '@/composables/useLitium';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useMyInformation from '@/composables/useMyInformation';

import PhoneInput from '@/components/forms/PhoneInput.vue';
import ErrorMessage from '@/components/forms/ErrorMessage.vue';
import { ERRORS } from '@/composables/constants';
import useUser from '@/composables/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonGeneralInfo',
  setup(__props) {

const { user } = useUser();
const { channel, cart, navigateToLoginPage } = useContext();
const { toLitiumMediaUrl } = useLitium();
const { websiteText } = useWebsiteTexts();
const { requestPending, uploadProfileImage, savePersonalInfo } =
  useMyInformation();

const isMounted = ref(false);

const newImage: any = ref(null);

const firstName = ref('');
const firstNameError = ref('');
const lastName = ref('');
const lastNameError = ref('');
const phoneNumber = ref('');
const phoneNumberError = ref('');

const title = ref('');
const bio = ref('');

const savePersonalInfoError = ref('');

const profileImage = computed(() => {
  if (!user.value?.person?.profileImageId) {
    return '';
  }
  return (
    toLitiumMediaUrl(user.value?.person?.profileImageId, {
      maxHeight: 140,
    })
  );
});

const phoneCountry = computed(() => {
  if (phoneNumber.value) {
    const prefix = phoneNumber.value.split(' ')[0].replace('+', '');
    const matchingPrefix = (
      channel.value?.website?.websiteFields?.PhonePrefixes || []
    ).find((p: any) => p.prefix === prefix);

    if (matchingPrefix) {
      return matchingPrefix.country;
    }
  }

  return cart.value.countryId;
});

function updatePhoneNumber(phoneNumberValue: string) {
  phoneNumber.value = phoneNumberValue;
  phoneNumberError.value = '';
}

function validatePersonalInfo() {
  let hasErrors = false;
  if (!firstName.value) {
    firstNameError.value =
      websiteText('global__first_name_required').value ||
      'global__first_name_required';
    hasErrors = true;
  }

  if (!lastName.value) {
    lastNameError.value =
      websiteText('global__last_name_required').value ||
      'global__last_name_required';
    hasErrors = true;
  }

  const parsedNumber = parsePhoneNumberFromString(
    phoneNumber.value,
    phoneCountry.value
  );

  if (!parsedNumber || !parsedNumber.isValid()) {
    phoneNumberError.value =
      websiteText('global__invalid_phone').value || 'global__invalid_phone';
    hasErrors = true;
  }

  return hasErrors;
}

function onFirstNameFocused() {
  firstNameError.value = '';
  onLastNameFocused();
}

function onLastNameFocused() {
  lastNameError.value = '';
}

function handleImage(e: any) {
  const images = e.target.files || [];
  for (let i = 0; i < images.length; i++) {
    if (i === images.length - 1) {
      convertToBase64Image(images[i]);
    }
  }
}

function convertToBase64Image(fileImage: any) {
  const reader = new FileReader();
  reader.onload = (e: any) => {
    const img: any = new Image();
    img.src = e.target.result;
    img.onload = () => {
      newImage.value = {
        name: fileImage.name,
        type: fileImage.type,
        src: img.src,
      };
    };
  };
  reader.readAsDataURL(fileImage);
}

async function submitPersonalInfoForm() {
  savePersonalInfoError.value = '';
  const hasErrors = validatePersonalInfo();

  if (hasErrors) {
    return;
  }

  const parsedNumber = parsePhoneNumberFromString(
    phoneNumber.value,
    phoneCountry.value
  );

  if (newImage.value) {
    await uploadProfileImage(newImage.value);
  }

  const response = await savePersonalInfo({
    firstName: firstName.value,
    lastName: lastName.value,
    phoneNumber: `+${parsedNumber?.countryCallingCode} ${parsedNumber?.nationalNumber}`,
    title: title.value || '',
    bio: bio.value || '',
  });

  if(response.error != 'NONE'){
    if(response.error == ERRORS.NOT_AUTHENTICATED){
      return navigateToLoginPage();
    }
    savePersonalInfoError.value =
      websiteText('global__save_error').value || 'global__save_error';
  }
}

onMounted(() => {
  firstName.value = user.value?.person?.firstName;
  lastName.value = user.value?.person?.lastName;
  phoneNumber.value = user.value?.person?.phone;
  title.value = user.value?.person?.title;
  bio.value = user.value?.person?.bio;

  isMounted.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(websiteText)('mypages__my_infomation').value || 'mypages__my_infomation'), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (isMounted.value && _unref(profileImage) && !newImage.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(profileImage),
              loading: "lazy",
              class: "person-general-info__profile-image"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (newImage.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: newImage.value.src,
              class: "person-general-info__profile-image"
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (isMounted.value && !_unref(profileImage) && !newImage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, [
          _createElementVNode("input", {
            type: "file",
            id: "pperson-general-info__file-upload",
            class: "pperson-general-info__upload-button",
            accept: "image/*",
            multiple: "true",
            onChange: handleImage
          }, null, 32),
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_unref(websiteText)('global__upload_image').value || 'global__upload_image'), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(websiteText)('global__first_name').value || 'global__first_name'), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "firstName",
        autocomplete: "given-name",
        class: "person-general-info__input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firstName).value = $event)),
        onInput: onFirstNameFocused
      }, null, 544), [
        [_vModelText, firstName.value]
      ]),
      (firstNameError.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            message: firstNameError.value
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(websiteText)('global__last_name').value || 'global__last_name'), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "lastName",
        autocomplete: "family-name",
        class: "person-general-info__input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastName).value = $event)),
        onInput: onLastNameFocused
      }, null, 544), [
        [_vModelText, lastName.value]
      ]),
      (lastNameError.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            message: lastNameError.value
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(websiteText)('global__phone').value || 'global__phone'), 1),
      _createVNode(PhoneInput, {
        id: "phoneInput",
        class: "person-general-info__phone-input",
        value: phoneNumber.value,
        "selected-country": _unref(phoneCountry),
        placeholder: _unref(websiteText)('global__phone').value || 'global__phone',
        "error-message": phoneNumberError.value,
        onInput: updatePhoneNumber
      }, null, 8, ["value", "selected-country", "placeholder", "error-message"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(websiteText)('global__customer_title').value || 'global__customer_title'), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "title",
        autocomplete: "organization-title",
        class: "person-general-info__input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((title).value = $event))
      }, null, 512), [
        [_vModelText, title.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(websiteText)('global__customer_bio').value || 'global__customer_bio'), 1),
      _withDirectives(_createElementVNode("textarea", {
        type: "text",
        id: "bio",
        class: "person-general-info__input",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((bio).value = $event)),
        rows: "4"
      }, null, 512), [
        [_vModelText, bio.value]
      ])
    ]),
    _createElementVNode("button", {
      class: "secondary-button secondary-button--inverted person-general-info__button",
      onClick: submitPersonalInfoForm,
      disabled: _unref(requestPending)
    }, _toDisplayString(_unref(websiteText)('global__save').value || 'global__save'), 9, _hoisted_21),
    (savePersonalInfoError.value)
      ? (_openBlock(), _createBlock(ErrorMessage, {
          key: 0,
          message: savePersonalInfoError.value
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ]))
}
}

})